export default __webpack_public_path__ + "static/media/no_image.22d2aa4d.jpg";